import styled from 'styled-components';

export const StartValidationContainer = styled.article`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem 1rem;

  strong {
    color: ${(props) => props.theme.colors.grayDark3};
  }

  .item {
    font-size: 14px;
  }

  p.item {
    margin-bottom: 0;
  }

  p.title {
    margin-bottom: 0;
  }
`;

export const StartValidationJumbotron = styled.section`
  background-color: ${(props) => props.theme.colors.gray8};
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem 1rem 0.5rem 1rem;

  .jumbotronContent {
    footer {
      max-width: 1200px;
    }
  }
`;
